<p-table [value]="allFOBPoints" dataKey="id">
    <ng-template pTemplate="header">
        <tr>
            <th>Name</th>
            <th>Is Active</th>
            <th>Is Default</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-fob>
        <tr>
            <td>{{fob.name}}</td>
            <td>{{fob.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.No}}</td>
            <td>
               <p-radioButton [disabled]="fob.statusId==statusConstants.INACTIVE" [value]="true" [(ngModel)]="fob.isDefault"
               (onClick)="fobDefault(fob)"></p-radioButton>
              {{fob.isDefault?answertypeConstants.Yes: answertypeConstants.No}}
            </td>
            <td class="action">
                <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"><i class="pi
             pi-pencil" (click)="showEditFOB(fob)"></i></span>
                <span class="btnBars p-mr-0" *ngIf="fob.createdSource!='system'" pTooltip="Delete" (click)="deleteFOB(fob)" tooltipPosition="top"><i
                        class="pi pi-trash"></i></span>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="{{addEditFOBHeader}}" [(visible)]="displayFOBAdd" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}">
    <form [formGroup]="fobPointForm">
        <div class="header">
            <h5>FOB Point Information
                <p-inputSwitch class="header-switch" [disabled]="statusDisabled" formControlName="statusId"></p-inputSwitch>
            </h5>
        </div>
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-6">
                    <label>Name<span style="color: red;">*</span></label>
                    <input pInputText type="text" id="fobName" name="fobName" formControlName="name" />
                    <small *ngIf="invalidData" class="p-invalid">Name already exists.</small>
                </div>
                <div class="p-col-6">
                    <label>Finance Account<span style="color: red;">*</span></label>
                    <p-treeSelect class="border-bottom-input" [options]="financialAccounts" appendTo="body" 
                    formControlName="financialAccountId" display="comma" placeholder="Select Financial Account"
                    [metaKeySelection]="false" selectionMode="single"></p-treeSelect>
                  </div>
            </div>
        </div>
    </form>

    <p-footer>
        <button type="button" pButton (click)="displayFOBAdd=false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton [disabled]="!fobPointForm.valid" (click)="saveFOB(fobPointForm.value)" label="Save"></button>
    </p-footer>
</p-dialog>